/*
 * Crystal Flare — cart upsell.
 * Adds the selected variant to the cart and re-renders the cart sections in
 * place, using Shopify's own Cart AJAX and Section Rendering APIs.
 */
(function () {
  const ROOT = '.cf-upsell';
  const routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function parseSection(html, selector) {
    if (!html) return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  function cartTargets() {
    const targets = [];
    ['main-cart-items', 'main-cart-footer'].forEach((id) => {
      const el = document.getElementById(id);
      if (el && el.dataset.id) targets.push({ sectionId: el.dataset.id, el: el });
    });
    return targets;
  }

  function setLoading(button, isLoading) {
    const spinner = button.querySelector('.loading__spinner');
    button.classList.toggle('is-loading', isLoading);
    button.disabled = isLoading;
    if (spinner) spinner.classList.toggle('hidden', !isLoading);
  }

  function announce(root, message) {
    const status = root && root.querySelector('.cf-upsell__status');
    if (status) status.textContent = message;
  }

  /*
   * The Essential free shipping bar sits outside the cart footer's
   * .js-contents, so the section re-render never touches it and it keeps
   * showing the amount from page load. The app renders the bar client-side
   * and exposes the function it uses to re-read the cart, so call that.
   * No-ops if the app is gone.
   */
  function refreshFreeShippingBar() {
    const poll = window.pollCartTotalEssentialApps;
    if (typeof poll !== 'function') return;

    const run = () => {
      try {
        poll();
      } catch (error) {
        console.error('[cf-cart-upsell] free shipping bar refresh failed', error);
      }
    };

    // The app throttles itself for 300ms after each run. If it is mid-throttle
    // our call would be dropped, so wait it out instead.
    const configs = window.freeShippingBarConfigs;
    if (configs && configs.threshold) {
      setTimeout(run, 400);
    } else {
      run();
    }
  }

  function updateArrows(root) {
    const track = root.querySelector('.cf-upsell__track');
    const prev = root.querySelector('[data-direction="prev"]');
    const next = root.querySelector('[data-direction="next"]');
    if (!track || !prev || !next) return;

    const scrollable = track.scrollWidth - track.clientWidth > 4;
    root.querySelector('.cf-upsell__nav').hidden = !scrollable;
    prev.disabled = track.scrollLeft <= 4;
    next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
  }

  function initAll() {
    document.querySelectorAll(ROOT).forEach((root) => {
      if (root.dataset.cfReady) return;
      root.dataset.cfReady = 'true';
      const track = root.querySelector('.cf-upsell__track');
      if (track) track.addEventListener('scroll', () => updateArrows(root), { passive: true });
      updateArrows(root);
    });
  }

  async function refreshSelf(root) {
    const sectionId = root.dataset.sectionId;
    if (!sectionId) return;
    try {
      const res = await fetch(`${window.location.pathname}?section_id=${sectionId}`);
      const html = await res.text();
      const next = parseSection(html, ROOT);
      if (next) {
        root.replaceWith(next);
        initAll();
      } else {
        root.remove();
      }
    } catch (error) {
      console.error('[cf-cart-upsell] refresh failed', error);
    }
  }

  async function addToCart(button) {
    const root = button.closest(ROOT);
    const targets = cartTargets();
    const sectionIds = targets.map((t) => t.sectionId);
    if (root.dataset.sectionId) sectionIds.push(root.dataset.sectionId);
    sectionIds.push('cart-icon-bubble');

    setLoading(button, true);

    try {
      const response = await fetch(`${routes}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
          sections: sectionIds.join(','),
          sections_url: window.location.pathname,
        }),
      });

      const state = await response.json();
      if (state.status) throw new Error(state.description || state.message || 'Add to cart failed');

      const sections = state.sections || {};

      targets.forEach((target) => {
        const next = parseSection(sections[target.sectionId], '.js-contents');
        const current = target.el.querySelector('.js-contents');
        if (next && current) current.innerHTML = next.innerHTML;
        target.el.classList.remove('is-empty');
      });

      const bubble = document.getElementById('cart-icon-bubble');
      const bubbleNext = parseSection(sections['cart-icon-bubble'], '.shopify-section');
      if (bubble && bubbleNext) bubble.innerHTML = bubbleNext.innerHTML;

      refreshFreeShippingBar();
      announce(root, 'Added to your cart.');

      const selfHtml = sections[root.dataset.sectionId];
      if (selfHtml) {
        const next = parseSection(selfHtml, ROOT);
        if (next) {
          root.replaceWith(next);
          initAll();
        } else {
          root.remove();
        }
      } else {
        setLoading(button, false);
      }
    } catch (error) {
      console.error('[cf-cart-upsell]', error);
      setLoading(button, false);
      announce(root, 'Something went wrong. Please try again.');
    }
  }

  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('.cf-upsell__arrow');
    if (arrow) {
      const root = arrow.closest(ROOT);
      const track = root.querySelector('.cf-upsell__track');
      const card = track.querySelector('.cf-upsell__card');
      const step = card ? card.offsetWidth + 10 : track.clientWidth;
      track.scrollBy({ left: arrow.dataset.direction === 'next' ? step : -step, behavior: 'smooth' });
      return;
    }

    const button = event.target.closest('.cf-upsell__add');
    if (!button || button.disabled) return;
    event.preventDefault();
    addToCart(button);
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('.cf-upsell__variants');
    if (!select) return;

    const card = select.closest('.cf-upsell__card');
    const option = select.options[select.selectedIndex];
    const price = card.querySelector('.cf-upsell__price');
    const button = card.querySelector('.cf-upsell__add');

    if (price && option.dataset.priceHtml) price.innerHTML = option.dataset.priceHtml;
    if (button) button.dataset.variantId = option.value;
  });

  document.addEventListener('DOMContentLoaded', initAll);
  initAll();

  if (typeof subscribe === 'function') {
    subscribe('cart-update', (event) => {
      if (event && event.source === 'cf-cart-upsell') return;
      // Covers the theme's own quantity and remove controls, which leave the
      // free shipping bar stale for the same reason.
      refreshFreeShippingBar();
      document.querySelectorAll(ROOT).forEach(refreshSelf);
    });
  }
})();
